import { MailIcon } from "@heroicons/react/solid"

export interface CheckoutPrePurchaseProps {
  emailAddress: string
  emailAddressSuggestion: string | null
  isProcessing: boolean
  onLogOut: () => void
  setEmailAddress: (email: string) => void
  userEmail: string | null
  userFirstName: string | null
  userIsAnonymous: boolean
}
export default function CheckoutPrePurchase({
  emailAddress,
  emailAddressSuggestion,
  isProcessing,
  onLogOut,
  setEmailAddress,
  userEmail,
  userFirstName,
  userIsAnonymous,
}: CheckoutPrePurchaseProps) {
  return (
    <div className="max-w-md" data-component="checkout-pre-purchase">
      <h2 className="font-browser font-medium text-lg">Email Address</h2>
      {!userIsAnonymous && (
        <p className="font-browser text-sm">
          You are logged in securely as {userEmail}. Not{" "}
          {userFirstName || "you"}?{" "}
          <button
            className="inline text-orange underline"
            onClick={() => onLogOut()}
          >
            Click here to log out
          </button>
        </p>
      )}
      {userIsAnonymous && (
        <>
          <p className="font-browser text-sm">
            This is where we&#8217;ll send your order confirmation and how
            you&#8217;ll log in to view your past orders.
          </p>
          <div className="mt-2">
            <div className="mt-1 flex rounded-md shadow-sm">
              <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  className="block w-full rounded-none rounded-l-sm p-2 pl-10 border border-gray-400 outline-none"
                  id="email"
                  name="email"
                  onChange={(ev) => {
                    setEmailAddress(ev.target.value)
                  }}
                  placeholder="me@email.com"
                  readOnly={isProcessing}
                  type="email"
                  value={emailAddress}
                />
              </div>
            </div>
          </div>
          {emailAddressSuggestion && (
            <button
              className="mt-1 font-medium text-orange text-xs"
              onClick={() => {
                setEmailAddress(emailAddressSuggestion)
              }}
            >
              Did you mean {emailAddressSuggestion}?
            </button>
          )}
        </>
      )}
    </div>
  )
}
